<template>
  <div class="body">
    <el-container>
      <UsersAside @toggle="toggle($event)" />
      <el-main>
        <el-card>
          <div slot="header" class="clearfix">
            <span>المستخدمين</span>
            <el-button
              v-if="accessLinks('add_employee')"
              style="float: left"
              @click="showAddModal = true"
              type="success"
              >اضافة مستخدم</el-button
            >
          </div>
          <el-table :data="usersList" class="users">
            <el-table-column label="#" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="الاسم" prop="name"></el-table-column>
            <el-table-column label="الاجراء" width="220">
              <template slot-scope="scope">
                <el-row :gutter="10">
                  <el-col :md="6" v-if="accessLinks('edit_employee')">
                    <el-button
                      @click="showScope('data',scope)"
                      size="mini"
                      type="success"
                      title="تعديل"
                      icon="el-icon-edit"
                    ></el-button>
                  </el-col>
                  <el-col :md="18" v-if="accessLinks('edit_employee')">
                    <el-button
                      @click="showScope('password',scope)"
                      size="mini"
                      type="warning"
                      title="تغيير كلمة المرور"
                      icon="el-icon-edit"
                    >تغيير كلمة المرور</el-button>
                  </el-col>
                  <!-- <el-col :md="5">
                    <el-popconfirm
                      confirm-button-text="موافق"
                      cancel-button-text="إلغاء"
                      icon="el-icon-info"
                      icon-color="red"
                      :title="'هل تريد حذف ' + ' ' + scope.row.name + ' ؟'"
                      @confirm="deleteItem(scope.row.id)"
                    >
                      <el-button
                        slot="reference"
                        type="danger"
                        title="مسح"
                        icon="el-icon-delete"
                        size="mini"
                      ></el-button>
                    </el-popconfirm>
                  </el-col> -->
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-dialog
          :fullscreen="false"
          title="اضافة مستخدم جديد"
          :visible.sync="showAddModal"
        >
          <el-form
            :rules="addRules"
            ref="NewUser"
            :model="addForm"
            label-width="120px"
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="الاسم" prop="name">
                  <el-input
                    class="input1"
                    @focus="$event.target.select()"
                    v-model="addForm.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="كلمة المرور" prop="password">
                  <el-input
                    class="input2"
                    type="password"
                    :show-password="true"
                    suffix-icon="el-icon-lock"
                    @focus="$event.target.select()"
                    v-model="addForm.password"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="تاكيد كلمة المرور" prop="confirmPassword">
                  <el-input
                    class="input2"
                    type="password"
                    :show-password="true"
                    suffix-icon="el-icon-lock"
                    @focus="$event.target.select()"
                    v-model="addForm.confirmPassword"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="الفرع" prop="branch_id">
                  <el-select
                    id="input3"
                    class="input3"
                    v-model="addForm.branch_id"
                    clearable
                    placeholder="الفرع"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(branch, i) in branchList"
                      :key="'br' + i"
                      :label="branch.name + ' - ' + branch.address"
                      :value="branch.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="24" :sm="24">
                <el-form-item label="الصلاحيه" prop="role_id">
                  <el-select
                    id="input4"
                    class="input4"
                    v-model="roles_id"
                    clearable
                    @change="addRoles"
                    placeholder="الصلاحيه"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(role, i) in rolesList"
                      :key="'br' + i"
                      :label="role.name"
                      :value="role.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="addUser()"
              >تسجيل</el-button
            >
            <el-button class="mr-3" @click="cancelAdd()"
              >إلغاء</el-button
            >
          </span>
        </el-dialog>
        <el-dialog
          :fullscreen="false"
          title="تغيير كلمة المرور"
          :visible.sync="editPassword"
          v-if="selectedUser"
        >
          <el-form
            :rules="rulesPassword"
            ref="editPassword"
            :model="formPassword"
            label-width="120px"
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="كلمة المرور الجديده" prop="password">
                  <el-input
                    type="password"
                    :show-password="true"
                    suffix-icon="el-icon-lock"
                    @focus="$event.target.select()"
                    v-model="formPassword.password"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="تاكيد كلمة المرور" prop="confirmPassword">
                  <el-input
                    type="password"
                    :show-password="true"
                    suffix-icon="el-icon-lock"
                    @focus="$event.target.select()"
                    v-model="formPassword.confirmPassword"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="UpdatePassword"
              >حفظ التعديلات</el-button
            >
            <el-button class="mr-3" @click="editPassword = false"
              >إلغاء</el-button
            >
          </span>
        </el-dialog>
        <el-dialog
          :fullscreen="false"
          title="تعديل بيانات مستخدم"
          :visible.sync="editFormVisible"
          v-if="selectedUser"
        >
          <el-form
            :rules="rules"
            ref="EditUser"
            :model="selectedUser"
            label-width="120px"
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="الاسم" prop="name">
                  <el-input
                    class="input1"
                    @focus="$event.target.select()"
                    v-model="selectedUser.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="الفرع" prop="branch_id">
                  <el-select
                    id="input3"
                    class="input3"
                    v-model="selectedUser.branch_id"
                    clearable
                    placeholder="الفرع"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(branch, i) in branchList"
                      :key="'br' + i"
                      :label="branch.name + ' - ' + branch.address"
                      :value="branch.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="24" :sm="24">
                <el-form-item label="الصلاحيه" prop="role_id">
                  <el-select
                    id="input4"
                    class="input4"
                    v-model="roles_id"
                    clearable
                    placeholder="الصلاحيه"
                    style="width: 100%"
                    @change="addRoles"
                  >
                    <el-option
                      v-for="(role, i) in rolesList"
                      :key="'br' + i"
                      :label="role.name"
                      :value="role.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="editUser"
              >حفظ التعديلات</el-button
            >
            <el-button class="mr-3" @click="editFormVisible = false"
              >إلغاء</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import UsersAside from "@/components/UsersAside.vue";
import axiosApi from "@/plugins/axios.js";
export default {
  components: { UsersAside },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("من فضلك اكد كلمة المرور"));
      } else if (value !== this.formPassword.password) {
        callback(new Error("كملة المرور غير متطابقه"));
      } else {
        callback();
      }
    };
    var validateAddPass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("من فضلك اكد كلمة المرور"));
      } else if (value !== this.addForm.password) {
        callback(new Error("كملة المرور غير متطابقه"));
      } else {
        callback();
      }
    };
    return {
      activeSide: true,
      usersList: [],
      editFormVisible: false,
      showAddModal: false,
      isLoading: false,
      selectedUser: {
        id: "",
        name: "",
        roles: [],
        branch_id: "",
      },
      formPassword: {
        id: "",
        name: "",
        roles: [],
        branch_id: "",
        password: "",
        confirmPassword: "",
      },
      addForm: {
        name: "",
        password: "",
        confirmPassword: "",
        roles: [],
        branch_id: "",
      },
      rules: {
        name: [
          { required: true, message: "حدد اسم المستخدم", trigger: "blur" },
        ],
        roles: [{ required: true, message: "حدد الصلاحية", trigger: "blur" }],
        branch_id: [{ required: true, message: "حدد الفرع", trigger: "blur" }],
      },
      addRules: {
        name: [
          { required: true, message: "حدد اسم المستخدم", trigger: "blur" },
        ],
        password: [
          { required: true, message: "حدد الرقم السري", trigger: "blur" },
        ],
        confirmPassword: [{ validator: validateAddPass2, trigger: "blur" }],
        roles: [{ required: true, message: "حدد الصلاحية", trigger: "blur" }],
        branch_id: [{ required: true, message: "حدد الفرع", trigger: "blur" }],
      },
      rulesPassword: {
        password: [
          { required: true, message: "حدد الرقم السري", trigger: "blur" },
        ],
        confirmPassword: [{ validator: validatePass2, trigger: "blur" }],
      },
      roles_id: "",
      rolesList: [],
      branchList: [],
      editPassword: false
    };
  },
  methods: {
    cancelAdd() {
      this.showAddModal = false;
      this.roles_id = "",
      this.addForm = {
        name: "",
        password: "",
        confirmPassword: "",
        roles: [],
        branch_id: "",
      };
    },
    getUsers() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi.get("users").then((res) => {
        this.usersList = res.data.data;
      }).catch((err)=>{
        console.log(err);
      }).finally(()=>{
        loading.close();
      })
    },
    editUser() {
      this.$refs["EditUser"].validate((valid)=>{
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "جاري تسجيل المستخدم",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .put(`users/${this.selectedUser.id}`, this.selectedUser)
            .then((res) => {
              this.usersList = res.data;
              this.editFormVisible = false;
              this.selectedUser = {
                id: "",
                name: "",
                password: "",
                confirmPassword: "",
                roles: [],
                branch_id: "",
              };
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات المستخدم بنجاح",
                type: "success",
                duration: 1500,
              });
            })
            .catch((err) => {
              this.$notify.error({
                title: "حدث خطأ",
                message: "عفوا تأكد من بيانات المستخدم",
                duration: 1500,
              });
              console.log(err);
            })
            .finally(() => {
              loading.close();
            });
        }
      })
    },
    UpdatePassword() {
      this.$refs["editPassword"].validate((valid)=>{
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "جاري تسجيل المستخدم",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .put("users", {
              id: this.formPassword.id,
              name: this.formPassword.name,
              password: this.formPassword.password,
            })
            .then((res) => {
              this.usersList = res.data;
              this.editPassword = false;
              this.formPassword = {
                id: "",
                name: "",
                password: "",
                confirmPassword: "",
                roles: "",
                branch_id: "",
              };
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات المستخدم بنجاح",
                type: "success",
                duration: 1500,
              });
            })
            .catch((err) => {
              this.$notify.error({
                title: "حدث خطأ",
                message: "عفوا تأكد من بيانات المستخدم",
                duration: 1500,
              });
              console.log(err);
            })
            .finally(() => {
              loading.close();
            });
        }
      })
    },
    toggle(active) {
      this.activeSide = active;
    },
    showScope(type,scope) {
      switch (type) {
        case "password":
          this.editPassword = true;
          this.formPassword = { ...scope.row };
          break;
        case "data":
          this.editFormVisible = true;
          this.selectedUser = { ...scope.row };
          this.roles_id = this.selectedUser.roles[0]
          break;
        default:
          break;
      }
      console.log(scope.row);
    },
    deleteItem(_id) {
      axiosApi.delete(`users/${_id}`).then((res)=>{
        console.log(res);
      })
      console.log(_id);
    },
    addRoles() {
      this.selectedUser.roles = [];
      this.selectedUser.roles.push(this.roles_id);
      this.addForm.roles.push(this.roles_id);
    },
    addUser() {
      this.$refs["NewUser"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تسجيل المستخدم",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .post("users", this.addForm)
            .then(() => {
              this.$refs["NewUser"].resetFields();
              this.roles_id = ""
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات المستخدم بنجاح",
                type: "success",
                duration: 1500,
              });
              this.getUsers();
              this.showAddModal = false;
            })
            .catch((err) => {
              this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من بيانات المستخدم",
                  duration: 1500,
                });
              console.log(err);
            })
            .finally(()=>{
              loading.close();
              this.isLoading = false;
            });
        } else {
          console.log("error");
          return false;
        }
      });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
  mounted() {
    this.getUsers();
    axiosApi.get("roles").then((res) => {
      this.rolesList = res.data.data;
      console.log("roles", res);
    });
    axiosApi.get("branches").then((res) => {
      this.branchList = res.data;
      console.log("branches", res);
    });
  },
};
</script>

<style lang="scss">
.users {
  .el-table__header-wrapper {
    th {
      border-color: #fff;
      background-color: #e6e6e6;
      border-bottom: 5px solid #fff !important;
    }
  }
  .el-table__body-wrapper {
    td {
      border-color: #fff;
      background-color: #f6f6f6;
    }
  }
}
</style>

